/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import BigNumberJS from 'bignumber.js'
import styled, { css } from 'styled-components'

import { pxToVw } from 'src/functions/units'

import { useThemeContext } from '../../contexts/ThemeContext'
import FlexBox from '../Common/FlexBox'
import Icon from '../Icon'

type Props = {
  quantity: string
}

const Coupons = ({ quantity }: Props) => {
  const { colors } = useThemeContext()

  return (
    <StyledCoupon>
      <FlexBox as="span" alignItems="center" columnGap={8}>
        <Icon color={colors.primary} icon="coupon" size={22} />
        <FlexBox>
          <span>{`${quantity} STAMP${new BigNumberJS(quantity).isGreaterThan(1) ? 's' : ''}`}</span>
        </FlexBox>
      </FlexBox>
    </StyledCoupon>
  )
}

export default Coupons

export const StyledCoupon = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${pxToVw(16)};
  margin-right: ${pxToVw(5)};

  ${({ theme }) => css`
    ${theme.mediaQuery.mobile`
      font-size: ${pxToVw(16, 720)};
      margin-right: ${pxToVw(5, 720)};
    `}
  `}
`
